module.exports = __webpack_public_path__ + "static/media/Dodo Brands_.3dc25b42.jpg";